import { useEffect, useState } from 'react';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import './ScrollToTop.css';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () =>
      setIsVisible(window.pageYOffset > 400);

    window.addEventListener('scroll', toggleVisibility, { passive: true });
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  if (!isVisible) return null;

  return (
    <div className='scroll-top'>
      <a href='#top' aria-label='Scroll to top'>
        <ArrowUpwardIcon />
      </a>
    </div>
  );
};

export default ScrollToTop;
